import MockStorage from"../MockStorage";export default new MockStorage();